module.exports = __webpack_public_path__ + "img/طبیعی.70b4c2ea.png";